import { Controller } from '@hotwired/stimulus';
import { enableDoneButtonIfLastIncompleteItem } from '../utils/enable_done_button_if_last_incomplete_item';

export default class ActionItemButtonLinkController extends Controller {
  static targets = ['linkButton'];
  static values = {
    postUrl: String,
    csrfToken: String,
    completeClass: String
  };

  async onLinkClick() {
    const response = await fetch(this.postUrlValue, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.csrfTokenValue
      },
      body: JSON.stringify({
        complete: true
      })
    });

    if (response.status !== 200) {
      // TODO: need to log an error to loggly
      return;
    }

    const data = await response.json();
    this.dispatchCompleteEvent(data);
    enableDoneButtonIfLastIncompleteItem();
    this.markButtonComplete();
  }

  dispatchCompleteEvent(payload) {
    const event = new CustomEvent('actionItemCard.saveSuccess', {
      detail: payload
    });

    document.dispatchEvent(event);
  }

  markButtonComplete() {
    this.linkButtonTarget.classList.add(this.completeClassValue);
  }
}
